<template>
  <div v-show="searched" class="relate-div">
    <waterMark :num="5"></waterMark>
    <div class="relate-div">
      <template v-if="hasValue">
        <div class="message-option">
          <p class="title">公司薪酬概况：</p>
          <p class="content">{{ company['薪酬/职级/奖金机制'] }}</p>
        </div>
        <ul class="message-option">
          <li class="md5">
            <span>公司整体薪酬：</span>
            <span
              v-if="company.公司薪酬"
              :class="{ danger: showTable.type === '公司薪酬', 'alpha-tag': true }"
              @click="showMoneyTable(company.公司薪酬, '公司薪酬')"
              >{{ company.简称 }}</span
            >
          </li>
          <li>
            <span>职能模块薪酬：</span>
            <span
              :class="{
                danger: showTable.type === '职能模块薪酬' && showTable.key === label,
                'alpha-tag mr5 md5': true,
              }"
              v-for="(table, label) in company.职能模块薪酬"
              :key="label"
              @click="showMoneyTable(table, '职能模块薪酬', label)"
              >{{ label }}</span
            >
          </li>
          <li>
            <span>部门薪酬：</span>
            <span
              :class="{
                danger: showTable.type === '部门薪酬' && showTable.key === item._id,
                'alpha-tag mr5 md5': true,
              }"
              v-for="item in company.部门薪酬"
              :key="item._id"
              @click="showMoneyTable(item.departmentMoneyTable, '部门薪酬', item._id)"
              >{{ item.名称 }}</span
            >
          </li>
        </ul>
        <div class="message-option">
          <p>职级:<span>（点击职级查看对应的薪酬 ）</span></p>
          <div>
            <span
              :class="{ danger: showCol === tag.tag + index, 'alpha-tag mr5 md5': true }"
              v-for="(tag, index) in tags"
              :key="tag.tag + index"
              @click="toShowCol(tag, index)"
              >{{ tag.tag }}</span
            >
          </div>
          <ul class="money-detail-box">
            <li class="">
              <span>固薪：</span>
              <h4>{{ moneyDetail.固薪 }}<span v-if="moneyDetail.固薪 && showUnit(moneyDetail.固薪)">万</span></h4>
            </li>
            <li>
              <span>奖金：</span>
              <h4>{{ moneyDetail.奖金 }}<span v-if="moneyDetail.奖金 && showUnit(moneyDetail.奖金)">万</span></h4>
            </li>
            <li>
              <span>年薪：</span>
              <h4>{{ moneyDetail.年薪 }}<span v-if="moneyDetail.年薪 && showUnit(moneyDetail.年薪)">万</span></h4>
            </li>
            <li>
              <span>指标：</span>
              <h4>{{ moneyDetail.指标 }}<span v-if="moneyDetail.指标 && showUnit(moneyDetail.指标)">万</span></h4>
            </li>
            <li>
              <span>年限：</span>
              <h4>{{ moneyDetail.年限 }}<span v-if="moneyDetail.年限 && showUnit(moneyDetail.年限)">年</span></h4>
            </li>
          </ul>
        </div>
        <div class="message-option">
          <p class="md5">
            奖金机制：<span class="blod">{{ moneyTable.content['奖金机制'] }}</span>
          </p>
          <p class="md5">
            奖金发放时间：<span class="blod">{{ moneyTable.content['奖金发放时间'] }}</span>
          </p>
          <p class="md5">
            递延机制：<span class="blod">{{ moneyTable.content['递延机制'] }}</span>
          </p>
          <p class="md5">
            考核指标：<span class="blod">{{ moneyTable.content['考核指标'] }}</span>
          </p>
          <p class="md5">
            备注：<span class="blod">{{ moneyTable.content['备注'] }}</span>
          </p>
        </div>
        <div class="radish-btn radish-btn-primary radish-btn-small" @click="toEdit" style="float:right">编辑薪酬</div>
      </template>
      <template v-else>
        <h4>公司名称不正确，请修正后重新查询</h4>
      </template>
      <simpleMoneyTable
        ref="simpleMoneyTable"
        @refreshTable="loadData(companyName)"
        :companyName="companyName"
      ></simpleMoneyTable>
    </div>
  </div>
</template>
<script>
import simpleMoneyTable from '../component/simpleMoneyTable.vue'
const checkMoneyTable = (data, params) => {
  const { table = [], content = {} } = data

  const tableFields = ['专业职级', '管理职级', '指标', '年限', '固薪', '奖金']

  const contentFields = Object.keys(content)
  const tableVal = table.find(col => {
    let flag = false
    tableFields.forEach(v => {
      if (col[v]) flag = true
    })
    return flag
  })
  const contentVal = contentFields.find(field => {
    return content[field]
  })

  return tableVal || contentVal
}

export default {
  components: { simpleMoneyTable },
  data: function() {
    return {
      hasValue: true,
      company: {
        职能模块薪酬: [],
        部门薪酬: [],
      },
      moneyTable: { table: [], content: {} },
      tags: [],
      moneyDetail: {},
      companyName: '',
      searched: false,
      showTable: { type: '', key: '' },
      showCol: '',
    }
  },
  methods: {
    showUnit(val) {
      return !/[万,年]/.test(val)
    },
    toShowCol(tag, index) {
      this.moneyDetail = tag.data
      this.showCol = tag.tag + index
    },
    toEdit() {
      this.$refs.simpleMoneyTable.open()
    },
    showMoneyTable(val, type, key) {
      this.moneyTable = val
      this.moneyTable.table = this.moneyTable.table || []
      this.moneyTable.content = this.moneyTable.content || {}
      this.showTable.type = type
      this.showTable.key = key
      this.initTags()
    },
    init() {
      const category = Object.keys(this.company.职能模块薪酬)
      const department = this.company.部门薪酬
      if (this.company.公司薪酬) this.showMoneyTable(this.company.公司薪酬, '公司薪酬')
      else if (category.length !== 0) {
        this.showMoneyTable(this.company.职能模块薪酬[category[0]], '职能模块薪酬', category[0])
      } else if (department.length !== 0) {
        this.showMoneyTable(department[0].departmentMoneyTable, '部门薪酬', department[0]._id)
      } else {
        this.moneyTable = { table: [], content: {} }
      }
    },
    initTags() {
      const tags = this.moneyTable.table.map((val, index) => {
        return { tag: val.专业职级 || val.管理职级, index: index, data: val }
      })
      this.tags = tags.filter(val => val.tag)
      if (this.tags.length !== 0) this.toShowCol(this.tags[0], 0)
      else this.moneyDetail = {}
    },
    async loadData(companyName) {
      if (!companyName) {
        this.hasValue = false
        this.searched = false
        return this.$message('公司名称不能为空')
      }
      this.searched = true
      this.companyName = companyName
      const res = await app.service('company').searchMoneyTable(companyName)
      if (res.status === 'success') {
        res.data.部门薪酬 = res.data.部门薪酬.filter(v => checkMoneyTable(v.departmentMoneyTable))
        const arr = Object.keys(res.data.职能模块薪酬)
        arr.forEach(async v => {
          const result = checkMoneyTable(res.data.职能模块薪酬[v])
          if (!result) delete res.data.职能模块薪酬[v]
        })
        this.company = res.data
        this.init()
      } else this.$message(res.msg)
      this.hasValue = res.status === 'success'
    },
  },
}
</script>

<style scoped>
ul {
  padding: 0;
  list-style: none;
}
.message-option {
  border-bottom: 1px solid #eee;
  padding: 8px 0 8px;
}
.content {
  padding-left: 24px;
  font-size: 14px;
  font-weight: 700;
  font-style: normal;
  color: rgb(0, 0, 0);
  overflow-wrap: break-word;
  word-break: break-word;
}
.md5 {
  margin-bottom: 5px;
}
.money-detail-box {
  padding: 4px;
  box-sizing: border-box;
  border-radius: 8px;
  background-color: rgba(0, 153, 255, 0.15);
  border: 1px solid rgb(0, 153, 255);
  display: flex;
  justify-content: space-around;
}
.money-detail-box li {
  flex: 1;
}
h4 {
  font-size: 16px;
}
.blod {
  font-weight: 800;
}
</style>
